export default {
  'TextSwitchButton.LeftButton': ({ selectedValueId, leftValue }, outlet) => {
    if (selectedValueId !== leftValue.id) {
      outlet({ selectedId: leftValue.id })
    }
  },
  'TextSwitchButton.RightButton': ({ selectedValueId, rightValue }, outlet) => {
    if (selectedValueId !== rightValue.id) {
      outlet({ selectedId: rightValue.id })
    }
  },
}